export const transformQueryData = (input: any, overallQueryItemMapByTableName: Record<string, {tableName: string, columns: string[]}>) => {
  const tableDataMapById: any = {};

  input?.selected_values?.forEach((sel: any) => {
    const query = input.queries.find((q: any) => q.table === sel.table);
    if (query) {
      const columns =
        (Array.isArray(sel?.columns) && sel.columns.length > 0
          ? sel.columns
          : []) ?? [];
          // : overallQueryItemMapByTableName?.[sel?.table]?.columns) ?? [];
    
      tableDataMapById[sel.table] = {
        query_id: query.query_id,
        tableName: sel.table,
        columns, // reference from selected_values
        query: query.query, // reference from queries
        // isAllColumnsSelected: columns?.length === overallQueryItemMapByTableName?.[sel.table]?.columns?.length
        isAllColumnsSelected: (columns?.length === 0) || (columns?.length === overallQueryItemMapByTableName?.[sel.table]?.columns?.length),
      };
    }
  });

  const {
    queries, // exclude from final output
    selected_values, // exclude from final output
    ...rest // keep all other fields
  } = input;

  return {
    ...rest,
    selected_tables: selected_values.map((val: any) => val.table),
    table_data_map_by_id: tableDataMapById,
  };
};
